import { Footer } from "../components/Footer"
import { PayoutWireTransferMethods } from "../components/payout/PayoutWireTransferMethods"


export const PayoutWireTransferPage = () => {
    return (
        <div className="container">
            <PayoutWireTransferMethods />
            <Footer />
        </div>
    );
}